import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../environments/environment';

@Pipe({
  name: 'image',
})
export class ImagePipe implements PipeTransform {
  url: string = environment.apiURL;

  transform(value: unknown, ...args: unknown[]): string {
    const raw = String(value ?? '');
    const needsAuth = raw.includes('type=accreditamento');
    const token = localStorage.getItem('teatro-colosseo-backoffice-auth-token') || '';
    const sep = raw.includes('?') ? '&' : '?';
    const q = needsAuth && token ? `${sep}token=${encodeURIComponent(token)}` : '';
    return `${this.url}image/${raw}${q}`;
  }
}
